import { ymd } from "./util";

export const COLORS = {
  slate: "#64748b", red: "#ef4444", orange: "#f97316", yellow: "#eab308", green: "#22c55e",
  teal: "#14b8a6", blue: "#3b82f6", violet: "#8b5cf6", pink: "#ec4899",
};

export const FOLDER_COLORS = {
  "dispute-legal-log": "red", "proof-of-service": "blue", "receipts-tracking": "green",
  "vehicle-property": "orange", "daily-journal": "violet", appointments: "slate", health: "pink",
};

export const ENTRY_TYPES = ["Note", "Appointment", "Deadline", "Event", "Reminder"];

export const colorKey = (n) => n.color || FOLDER_COLORS[n.folderId] || "teal";
export const apptTime = (n) => (n.apptAt || "").slice(11, 16);
export const noteColor = (n) => COLORS[colorKey(n)];
export const noteDate = (n) => n.scheduledFor || ymd(new Date(n.createdAt));

export function monthGrid(year, month) {
  const start = new Date(year, month, 1 - new Date(year, month, 1).getDay());
  return Array.from({ length: 42 }, (_, i) => new Date(start.getFullYear(), start.getMonth(), start.getDate() + i));
}

export function groupByDate(notes) {
  const map = {};
  for (const n of notes) (map[noteDate(n)] = map[noteDate(n)] || []).push(n);
  Object.values(map).forEach((l) => l.sort((a, b) => (a.entryType === "Deadline" ? -1 : 0) - (b.entryType === "Deadline" ? -1 : 0) || (apptTime(a) || "99").localeCompare(apptTime(b) || "99") || a.createdAt.localeCompare(b.createdAt)));
  return map;
}
